(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    '<span translate="global.itemCount" translate-values="{first: $ctrl.queryCount === 0 ? 0 : (($ctrl.page - 1) * 20) + 1, second: ($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount, total: $ctrl.queryCount}">' +
                        'Showing {{ $ctrl.queryCount === 0 ? 0 : (($ctrl.page - 1) * 20) + 1 }} - ' +
                        '{{ ($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount }} ' +
                        'of {{ $ctrl.queryCount }} items.' +
                    '</span>' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('wamasysApp')
        .component('jhiItemCount', jhiItemCount);
})();
